import React from "react";

import { withShowIf } from "../../../../../../../../../../../../components/with-show-if/with-show-If.component";
import { SearchSuggestList } from "../../../../../../../../../../../../components/form-controls/search-suggest/search-suggest-results-list/search-suggest-results-list.component";
import { SearchSuggestListItem } from "../../../../../../../../../../../../components/form-controls/search-suggest/search-suggest-results-list-item/search-suggest-results-list-item.component";

import { PositionCategory } from "../../../../types/flyer-detail-page-form-position-categories/flyer-detail-page-form-position-categories.interface";

import { PositionCategoriesSearchResultsProps } from "./position-categories-search-results.props";

export const PositionCategoriesSearchResults = withShowIf(
  (props: PositionCategoriesSearchResultsProps) => {
    const onItemSelected = (item: PositionCategory) => () => props.onSelect(item);

    return (
      <SearchSuggestList>
        {props.results.map((result: PositionCategory, index: number) => (
          <SearchSuggestListItem key={index} onClick={onItemSelected(result)}>
            {result.name}
          </SearchSuggestListItem>
        ))}
      </SearchSuggestList>
    );
  }
);
